export default {
  errors: {
    wrong_brn_format: "Wrong BRN format",
    db_query_failed: "Error database connection",
    db_fetch_failed: "Error reading from the database",
    permission_denied: "You do not have permission to use this system",
    transaction_not_finish: "Transaction not finished",
    transaction_already_cancelled: "This transaction is already cancelled",
    transaction_in_invoice: "Cannot cancel: transaction is in an invoice",
    transaction_in_dms: "Cannot cancel: transaction is in a DMS batch",
    transaction_not_found: "Sale not found",
    date_wrong_format: "Invalid date format",
    network_unreachable: "Cannot reach the server. Please check your connection and try again.",
    session_expired: "Your session has expired. Please log in again and retry.",
    unexpected_server_error: "Server error (code {code}). Please retry; if it persists, contact the administrator.",
    status_invalid: "Invalid status for this operation",
    invalid_parameters: "The parameter provided is incorrect.",
    /* Add sales to an already-issued invoice — PUT /api/invoice/billings */
    invoice_not_found: "Invoice not found",
    invoice_add_status_invalid: "Cannot add: this invoice is not awaiting payment",
    invoice_add_billing_empty: "There is nothing to add to this invoice",
    invoice_add_billing_not_found: "The selected sale was not found",
    invoice_add_billing_in_invoice: "Cannot add: the sale is already bundled into another invoice",
    invoice_add_billing_person_diff: "Cannot add: the sale belongs to a different agent than the invoice",
    invoice_billing_list_mismatch: "This invoice's data is inconsistent — please contact the administrator",
    /* The invoice number is shared by several rows — pick the one you mean (send id) */
    invoice_number_ambiguous: "Several invoices share this number — please pick the one you mean from the list",
    // msw: "Error MSW API connection",
    msw_unknown_result: "Error reading from MSW API",
    invalid_param: "The parameter provided is incorrect.",
    msw: {
      numberblock_add_failed : "Create Number Block failed",
      number_create_failed :"Could not add this phone number to the system",
      number_delete_failed :"Could not delete this phone number from the system",
    },
    dtac: {
      idcard_validate_fail: "This BRN could not be found",
      subs_query_status_failed: "This phone number cannot be found on dtac's system.",
      subs_query_package_failed: "No information of this package was found on dtac's system.",
      wci_failed: "Could not create or add this phone number.",
      unknown_result: "Error reading from DTAC API",
      wci_queue: "Creating number in queue"
    },
    user: {
      duplicate: "Duplicate User information",
      duplicate_username: "Duplicate Username information",
      duplicate_email: "Duplicate email information",
      blcok_delete_by_self: "Can't delete data by yourself.",
      fail: "Error update user information",
      email_wrong_format: "Wrong email format",
      enterprise_empty: "Please select Enterprise",
    },
    corp: {
      duplicate: "Duplicate Corporate information",
      not_exist: "Organization information not found",
      check_number_fail: "The number checking is fail.",
      number_exist: "Error found number in Corporate",
      failed: "Error update Corporate information",
      create_failed: "Error create Corporate information",
      delete_failed: "Error delete Corporate information",
      user_exist : "Error found user in Corporate",
    },
    mlhg: {
      duplicate: "Duplicate Muti-line Hunting Group information",
      get_dummy_number_fail: "Information for dummy number for MLHG is not found",
      not_exist: "Not found this MLHG Information",
      member_not_exist: "Not found this number in this MLHG",
      member_not_in_corp: "Not found this number in this Enterprise",
      get_enterprise_fail: "Not found this Corporate",
      get_mlhg_fail: "Not found this MLHG",
      get_number_fail: "Not found this Number",
      get_pilot_fail: "Not found this Company Number",
      update_number_fail: "Update number in this MLHG failed",
      delete_number_fail: "Delete number in this MLHG failed",
      redeem_dummy_pilot_failed: "Cannot redeem dummy number",
      number_duplicate: "This number is duplicate in this MLHG"
    },
    auth: {
      login_fail: "Login Fail",
      block: "User has been blocked",
      login_success: "Login Success",
      logout_success: "Log out Success",
      unauthoriezed: "No permission",
      reset_invalid_token: "token invalid",
      reset_token_expired: "token reset_token_expired",
      forgot_password_fail: "forgot password failed",
      reset_password_fail: "reset password failed",
      username_wrong_format: "Wrong username format",
      password_wrong_format: "Wrong password format",
      token: "Invalid Token",
      password: "Invalid password",
      password_confirm: "Invalid confirm password",
    },
    package: {
      duplicate_code: "Package Code is Duplicate",
      duplicate_name: "Package Name is Duplicate",
      not_exist: "not found package information",
      delete_lock: "Cannot delete this package Because it is in use",
      get_profile_failed: "The VPBX package could not be found in the system."
    },
    subs: {
      not_exist: "This Number not exist",
      corp_not_match: "Corporate information not match",
      get_crop_id_failed: "Not found Corporate information or Company Number",
      comp_login_failed: "Cannot login to ComPortal",
      duplicate: "Duplicate Number",
      get_charge_number_failed: "Could not find telephone number information under this company.",
      set_charge_number_failed: " This phone number cannot be changed.",
      get_brn_failed: "Not found this BRN",
      is_mlhg_member: "This number is member of MLHG",
      number_range_delete_fail: "Cannot delete Number Range",
      comp_login_failed: "Error Login to ComPortal",
      subs_status_failed: "This Number is not eligible to subscribe this service",
      import: "Import number failed",
      reset_password_fail: "Reset password failed",
      delete_failed: "Delete number failed",
      delete_number_block_failed: "Delete Number Block failed",
    },
    profile : {
      change_profile_failed : "Change profile failed",
      change_password_failed : "Change password failed",
      password_confirm_not_match: "Error confirm password",
      password_confirm_wrong_format: "Wrogn password format.",
      password_old_wrong : "Wrong old password",

    }
  },

  bc_portal: "Web Portal",
  bc_package: "Package",
  bc_voicemail: "Voice Mail",
  bc_report: "Record Detail",
  bc_user: "User",
  bc_corporate: "Corporate",
  bc_mlhg: "Hunt Group",
  bc_pilot_number: "Company Number",
  bc_agent_number: "User Number",
  bc_change_profile: "Edit Profile",
  bc_change_password: "Edit Password",



  profile: {
    profile: "Profile",
    name: "Name",
    phone: "Phone",
    email: "E-Mail",
    change_password: "Change Password",
    password_old: "Old Password",
    password_new: "New Password",
    password_confirm: "Confirm Password",
    change_profile_success : "Change profile successed",
    change_password_success : "Change password successed",
    forgot_password_success : "Forgot password successed , Please check your email.",
    reset_password_success : "Reset password successed",
    role_super_admin: "Super Admin",
    role_branch_admin: "Branch Admin",
    role_agent: "Agent",
    role_user: "User",
  },
  menu: {
    corporate: "Corporate",
    mlhg: "Hunt Group",
    package: "Package",
    pilot_number: "Company Number",
    agent_number: "User Number",
    number: "Number",
    user: "User",
    bank: "Bank Accounts",
    billing: "Billing",
    billing_report: "Billing Report",
    invoice: "Invoices",
    branch: "Branch",
    insure: "Insurance Types",
    comm: "Commission",
    comm_extra: "Insurance Type List",
    payment: "Payments",
    ttype: "Sales Channel",
    person: "Agents",
    trans: "Sales",
    trans_cancel: "Cancelled Sales",
    customer: "Customers",
    cash_clear: "Cash Receipt Record",
    setting: "Settings",
    admin: "Administration",
    database: "Database",
    wht: "Withholding Tax Certificate",
    voicemail: "Voice Mail",
    cdr: "Record Detail",
    nseries: "Voice Conference",
    inventory: "Inventory",
    partner: "Partner",
    product: "Product",
    storage: "Storage",
    finance: "Finance Overview",
    quick_payment: "Quick Payment",
    promptpay: "PromptPay Accounts",
    dms: "DMS Submission",
    branch_money: "Branch Money"
  },
  nav: {
    primary: "Primary",
    toggleRail: "Collapse / expand menu",
    group: {
      sales: "Sales / Collections",
      documents: "Documents / Reports",
      database: "Database",
      settings: "Settings",
      admin: "Administration"
    },
    sec: {
      sellingDocs: "Sales documents",
      collections: "Collections",
      taxDocs: "Tax documents",
      reports: "Reports",
      salesMaster: "Sales master data",
      receivingMaster: "Receiving accounts"
    }
  },
  auth: {
    signin: "Sign In",
    signout: "Logout",
    username: "E-Mail or Number",
    email: "E-Mail",
    password: "Password",
    forgetpassword: "Forgot Password",
    resetpassword: "Reset Password"
  },
  corp: {
    name: "Corporate",
    brn: "BRN",
    code: "Code",
    create: "Create Corporate",
    create_success: "Successfully created the corporate",
    create_fail: "Failed to create corporate"
  },
  package: {
    name: "Package",
    code: "Package Code",
    create: "Create Package",
    profile: "Persistent Profile",
    cos: "Class Of Service",
    create_success: "Successfully created the package",
    create_fail: "Failed to create package"
  },
  number: {
    add: "Add Number",
    pilot: "Company Number",
    agent: "User Number",
    charge: "Charge Number",
    syncpackage: "Sync Package for all",
    create_success: "Successfully created the Number",
    agent_create: "Create User Number",
    pilot_create: "Create Company Number",
    pilot_create_success: "Successfully created the Company Number",
    pilot_create_fail: "Failed to create the Company Number",
    agent_create_success: "Successfully created the User Number",
    agent_create_fail: "Failed to create the User Number",
    bgadmin_login_fail: "Login BG Admin Failed",
    comportal_login_fail: "Login Comm Portal Failed",
    sync_package_success: "Sync package successed"
  },
  voicemail: {
    name: "Voice Mail",
    to: "to",
    from: "from",
    date: "date",
    corp: "Corporate"
  },
  report: {
    menu: "Record Detail",
    type: "Record Type",
    start: "Start",
    end: "End",
    duration: "Duration",
    corp: "Corporate"
  },
  user: {
    create: "Create User",
    name: "Name",
    username: "Username",
    type: "Type",
    phone: "Phone",
    role: "Role",
    create_success: "Create User successed",
    create_fail: "Create User failed",
    edit_unavailable: "This user cannot be edited (linked person record not found)"
  },
  mlhg: {
    name: "Hunt Group",
    failed: "Hunt Group failed",
    success: "Hunt Group successed"
  },
  lmg: {
    pool_balance: "Pool Balance",
    pool_transfer_total: "Transfer",
    pool_cash_total: "Cash",
    pool_reserve_total: "Reserve",
    pool_total: "Total",
    pool_by_account: "By Account",
    policy_status: "Per-Policy Status",
    paid_status: "Paid",
    payment_method: "Method",
    account: "Account",
    dms_submitted: "Submitted",
    dms_not_submitted: "Not Submitted",
    paid_yes: "Paid",
    paid_no: "Unpaid",
    dms_batch: "DMS Submission Batch",
    batch_number: "Batch Number",
    batch_date: "Submission Date",
    round: "Round",
    select_policies: "Select Policies",
    premium_original: "Original Premium",
    premium_adjusted: "Adjusted Premium",
    adjust_note: "Adjustment Note",
    submit_dms: "Submit DMS Batch",
    dms_pdf: "Attachment (PDF/Image)",
    dms_item_count: "Policy Count",
    dms_total: "Total Amount",
    dms_status: "Status",
    dms_status_submitted: "Submitted",
    dms_status_cancelled: "Cancelled",
    dms_filter_year: "Submission Year",
    dms_filter_all_months: "All months (whole year)",
    dms_filter_year_first: "Pick a year first",
    dms_filter_clear: "Clear filters",
    dms_paid_date: "Paid date",
    dms_unpaid: "Unpaid",
    dms_delete_confirm: "Delete this batch? Funds will be returned to the branch pool.",
    export_pdf: "Download PDF",
    export_xlsx: "Download Excel",
    agent: "Agent",
    card_number: "ID/Card Number",
    created: "Created",
    edit: "Edit",
    fname: "First Name",
    lname: "Last Name",
    extra_charge: "Extra Charge",
    address_customer: "Address",
    address_province: "Province",
    address_district: "District",
    address_subdistrict: "Sub-district",
    address_zipcode: "Postal Code",
    wht: "Withholding Tax Certificate",
    name: "North And East Broker",
    code: "Code",
    bank: "Bank Account",
    branch: "Branch",
    comm: "Commission Profile",
    comm_extra: "Insurance Type List",
    insure: "Insurance",
    insure_type: "Insurance Type",
    insure_plan: "Plan",
    data_type: "Data Type",
    insure_data_type: "Data Type",
    insure_data_type_1: "Motor Insurance",
    insure_data_type_2: "Health Insurance",
    insure_data_type_3: "Casualty Insurance (Building)",
    insure_data_type_4: "Casualty Insurance (Transport)",
    insure_data_type_5: "Miscellaneous Insurance",
    person: "Agent",
    ttype: "Sales Channel",
    user: "User",
    customer: "Customer",
    trans: "Sales List",
    sale_date: "Sale Date",
    detail: "Deductible (DD)",
    bank_name: "Bank Name",
    bank_account: "Bank Account Number",
    bank_code: "Branch Code",
    promptpay: "PromptPay",
    promptpay_enabled: "This account supports PromptPay",
    promptpay_type: "PromptPay Type",
    promptpay_id: "PromptPay ID",
    show_on_invoice: "Print this account number on the invoice",
    qr_on_invoice: "Use this account's PromptPay QR on the invoice",
    pp_type_phone: "Mobile Number",
    pp_type_taxid: "Tax ID / National ID",
    pp_type_ewallet: "e-Wallet ID",
    on_invoice: "On Invoice",
    account_type: "Account Type",
    account_type_hq: "Head Office",
    account_type_branch_transfer: "Branch Transfer",
    account_type_branch_cash: "Branch Cash",
    account_type_unset: "Unset",
    account_select: "Select receiving account",
    commission_deducted: "Commission deducted by agent",
    commission_amount: "Commission",
    visible_all_branch: "Visible to all branches",
    agent_code: "Agent Code",
    with_holding_tax: "Withholding Tax",
    tel: "Phone",
    email: "Email",
    address: "Address",
    subdistrict: "Sub-district",
    city: "District",
    province: "Province",
    postcode: "Postal Code",
    card_type: "Card Type",
    card_type_1: "ID Card",
    card_type_2: "Passport",
    card_type_3: "Juristic Person",
    transaction_id: "Transaction No.",
    cancel_trans: "Cancel Transaction",
    trans_create: "Create Transaction",
    trans_report_discount: "Discount Voucher",
    discount: "Discount",
    moreDiscount: "Special Discount",
    trans_report: "Sales Report",
    user_type: "User Type",
    billing: "Billing",
    billing_bill_id: "Billing No.",
    billing_paid_via: "Payment Method",
    billing_note: "Note",
    note: "Note",
    billing_period: "Installment",
    payment: "Payment",
    paid_type_cash: "Cash",
    paid_type_check: "Check",
    paid_type_transfer: "Bank Transfer",
    paid_file: "Payment Proof",
    paid_status: "Payment Status",
    paid_time: "Payment Time",
    paid_via: "Payment Method",
    paid_date: "Payment Date",
    view_detail: "View Detail",
    tranfer_image: "Transfer Proof",
    updated_at: "Last Updated",
    commission_percent: "% Commission",
    tax_percent: "% Tax",
    trans_type: "Work Type",
    recorder: "Recorder",
    due_date: "Due Date",
    due_round: "Billing Round",
    month: "Month",
    year: "Year",
    amount: "Amount",
    invoice_amount_all: "Total Premium",
    invoice_amount: "Net Premium",
    invoice_pay_amount: "Total Payable",
    sort: "Sort",
    comm_incentive: "Incentive (Baht)",
    comm_limitCnt: "Limit (Times per Year)",
    comm_amount: "Commission",
    comm_adjust: "Special Commission",
    comm_amount_percent: "Commission (%)",
    change_credit_limit: "Edit Credit Limit",
    credit: "Credit",
    credit_limit: "Credit Limit",
    credit_temp: "Temporary Credit Limit",
    credit_range: "Credit Period (Days)",
    person_upper: "Team Leader",
    person_type: "Sales Channel",
    owner_person: "Insurance Agent",
    policy_number: "Policy Number",
    dms_number: "DMS Number",
    license_plate: "License Plate",
    license_plate_min: "Licence plate needs at least 2 characters — this filter was skipped",
    taxid: "Tax ID",
    protection_date: "Coverage Period",
    cid: "ID Card / Passport Number",
    payment_method: "Payment Channel",
    payment_amount: "Amount Already Paid",
    trans_payment_amount: "Amount Due",
    payment_comm: "Commission Already Deducted",
    payment_date: "Payment Date",
    payment_create: "Create Payment",
    payment_source: "Source",
    paid_at_branch: "Paid at branch",
    payment_image: "Payment Proof",
    attachments: "Payment Proof (attachments)",
    add_files: "Select files (up to 5)",
    max_files_5: "Up to 5 files allowed",
    file_too_large: "File exceeds 5MB",
    file_type_invalid: "Only image or PDF files are allowed",
    remove_file: "Remove file",
    no_attachments: "No attachments",
    policy_start_date: "Coverage Start",
    policy_end_date: "Coverage End",
    trans_amount: "Net Premium",
    summary_amount: "Total Premium",
    trans_date: "Record Date",
    cash_clear: "Cash Outstanding with Staff",
    cash_clear_title: "Record Cash Received from Staff",
    cash_clear_date: "Date Cash Received from Staff",
    cash_clear_recorder: "Recorder of Cash Received from Staff",
    cash_clear_amount: "Amount Outstanding with Staff",
    cash_out_branch: "Cash Out from Branch",
    insure_year: "Year of Issue",
    trans_detail: "Item",
    age: "Age",
    insure_sum: "Sum Insured",
    car_model: "Car Model",
    car_year: "Car Year",
    billing_address: "Location",
    code_disaster: "Disaster Code",
    chassis_number: "Chassis Number",
    insurance_scope: "Scope",
    pay_amount: "Total Payable",
    tax_amount: "Discount Tax",
    net_amount: "Remaining",
    commission_discount: "Discount Deduction",
    billCharge: "Charge per Installment",
    renew: "Renew",
    policyNumberUpper: "Previous Policy Number",
    whTax: "Withholding Tax",
    invoice: "Invoice",
    invoice_number: "Invoice No.",
    invoice_add_billing: "Add sales to invoice",
    invoice_add_billing_hint: "Adding sales to invoice no.",
    invoice_add_billing_confirm: "Add these sales to the invoice?",
    invoice_add_billing_rows: "Rows to add",
    invoice_add_billing_success: "Sales added to the invoice",
    invoice_add_billing_fail: "Could not add the sales to this invoice",
    invoice_add_billing_no_rows: "No un-invoiced sales can be added to this invoice",
    invoice_add_billing_scope_agent: "Showing only un-invoiced sales for this agent",
    invoice_add_billing_scope_group: "Showing only un-invoiced sales in the direct-customer commission group (all discount tiers)",
    back: "Back",
    date: "Date",
    items: "Item",
    sale_list: "Sales List",
    finance_detail: "Bill Detail",
    finance_per_person: "Summary per Staff/Agent",
    finance_total: "Grand Total",
    finance_status_1: "Invoice Not Created",
    finance_status_2: "Invoice Created, Not Paid",
    finance_status_3: "Paid",
    finance_cash_submission: "Cash Submission from Staff",
    cash_clear_status: "Cash Status",
    cash_cleared: "Submitted",
    cash_outstanding: "Outstanding with Staff",
    cash_collected: "Collected",
    cash_total: "Total Cash",
    book_id: "Book No.",
    number_id: "No.",
    start_date: "Start Date",
    end_date: "End Date",
    effect_date: "Effective Date",
    car_type: "Car Type",
    refund_amount: "Net Premium Refund",
    refund_amount_all: "Total Premium Refund",
    per_page: "Items per Page",
    insure_data_type_other: "Other",
    insure_inactive_tag: "Inactive",
    insure_browse_roots: "Root categories",
    insure_browse_root: "Root",
    insure_browse_back: "Back",
    insure_browse_empty: "No sub-items",
    insure_browse_more_crumbs: "Hidden path",
    insure_browse_columns_aria: "Browse by columns",
    insure_select_to_view: "Select an item to view details",
    insure_level_n: "Level {n}",
    insure_status_active: "● Active",
    insure_status_inactive: "○ Inactive",
    insure_has_children_n: "Has {n} sub-categories",
    insure_no_children: "No sub-categories (leaf / product)",
    insure_action_add_child: "+ Add child",
    insure_action_add_sibling: "+ Add sibling",
    insure_action_edit: "Edit",
    insure_action_deactivate: "Deactivate",
    insure_action_reactivate: "Reactivate",
    insure_action_move: "Move to…",
    insure_deactivate_blocked: "Cannot deactivate: has sub-categories — move or delete them first",
    insure_move_soon: "Move feature — coming soon (Phase 2)",
    insure_search_empty: "No results",
    insure_search_more: "Show more",
    insure_search_leaf: "Leaf item",
    insure_search_branch: "Has children",
    insure_required: "Please select an insurance product",
    product_picker_placeholder: "Select an insurance product",
    product_picker_title: "Select insurance product",
    product_picker_search_placeholder: "Search insurance products…",
    product_picker_loading: "Loading…",
    product_picker_empty: "No products found",
    product_picker_clear: "Clear selection",
    insure_strip_prefix: "Hide outline numbers",
    insure_hide_type: "Hide type tags"
  },

  group_name: "Group Name",
  email: "E-Mail",
  email_optional: "E-Mail (Optional)",
  created: "Created",
  search: "Search",
  clear: "Clear",
  save: "Save",
  save_continue: "Save & continue",
  back: "Back",
  new: "New",
  edit: "Edit",
  status: "Status",
  download: "Download",
  downloadall: "Download All",
  search: "Search",
  welcome: "Welcome",
  myprofile: "Profile",
  changepassword: "Change Password",
  page_notfound: "Sorry Page not found.",
  page_notfound_desc: "Plase check URL again.",
  actions: "Menu",
  data: "Data ",
  to: "To",
  of: "Of",
  row_select: "rows selected",
  yes: "Yes",
  no: "No",
  ok: "Ok",
  cancel: "Cancel",
  upload_file: "Upload File",
  bg_admin: "Admin Setting",
  comportal: "Agent Setting",
  add: "Add",
  close: "Close",
  please_select: "Please select..",
  create: "Create",
  confirm: "Confirm",
  create_success: "Create success",
  delete_confirm: "Confirm delete",
  delete_confirm_text: "Please confirm delete ",
  delete_confirm_question: "Do you want to delete this information ? ",
  delete_success: "Delete successed",
  delete_fail: "Delete Failed",
  edit_success: "Editing successed",
  edit_fail: "Editing failed",
  cancel_success: "Cancelled successfully",
  cancel_fail: "Cancel failed"
};
